require('./lib/contactform')();
require('./lib/footer')();
require('./lib/nav')();
require('./lib/slider')();
require('./lib/smoothscroll')();


var OpeningTimes = require('openingtimes');

var openingTimes = new OpeningTimes(window.openingTimes);

function openingTimesHtml(groups) {
    var html = '';

    for (let i = 0; i < groups.length; i++) {
        const group = groups[i];
        html += `<time>${group.dateStr}: ${group.openingTime}<br></time>`;
    }

    return html;
}

function nowOpeningTimesHtml() {
    var html = '';
    var days = openingTimes.getOpeningTimesOfWeek();

    for (let i = 0; i < days.length; i++) {
        const day = days[i];
        html += `<li class="${day.exception ? 'exception ' : ''}${day.isToday ? 'today ' : ''}">
        <span>${day.dayName}</span>
        <div class="val">${openingTimes.formatOpeningTime(day.openingTimes)}</div>
        <div class="exceptionVal">${day.exception ? openingTimes.formatOpeningTime(day.exception) : ''}</div>
    </li>`;
    }

    return html;
}



function refreshTime() {
    $('.setRelativeTime').html(openingTimes.nextEvent());
    $('#openingExceptions').html(openingTimesHtml(openingTimes.groupExceptions()));

    $('#openingTimesViewData').html(nowOpeningTimesHtml());
}

setInterval(function () {
    refreshTime();
}, 60000);
refreshTime();